import type { Course } from "../../shared/types";

interface SubjectSwitchProps {
  courses: Course[];
  activeCourseId: string | undefined;
  computerSelected: boolean;
  onSelectCourse: (course: Course) => void;
  onSelectComputer: () => void;
}

export function SubjectSwitch({ courses, activeCourseId, computerSelected, onSelectCourse, onSelectComputer }: SubjectSwitchProps) {
  return (
    <section className="language-panel" aria-label="Learning subject">
      <div className="language-switch" role="group" aria-label="Learning subject switch">
        {courses.map(course => {
          const japanese = course.languageCode === "ja";
          const selected = !computerSelected && course.id === activeCourseId;
          return <button key={course.id} className={selected ? "active" : ""} type="button" aria-pressed={selected} onClick={() => onSelectCourse(course)}>
            <img className="subject-icon" src={`/icons/${japanese ? "japan" : "united-states"}.svg`} alt="" />
            <span className="subject-label" lang={japanese ? "ja" : "en"}>{japanese ? "日本語" : "English"}</span>
          </button>;
        })}
        <button className={computerSelected ? "active" : ""} type="button" aria-pressed={computerSelected} onClick={onSelectComputer}>
          <img className="subject-icon" src="/icons/computer.svg" alt="" />
          <span className="subject-label" lang="en">Computer</span>
        </button>
      </div>
    </section>
  );
}
